// Relative imports, not the '@' alias: jest has no moduleNameMapper for '@'
// and jest.config.js may not be touched. See useGeneratedCourse.ts.
import ChessRestClient from '../../Api/ChessRestClient';
import {getLocalStorage} from '../../Utils/CommonUtils';

/**
 * Turn a spoken question into text.
 *
 * Returns null rather than throwing when it cannot be made out, because the
 * caller's answer to that is the same as its answer to an empty recording:
 * say so, and leave the student to type it.
 */
export async function transcribeQuestion(
  bookUuid: string,
  audio: Blob,
): Promise<string | null> {
  const token = await getLocalStorage('access_token');
  const form = new FormData();
  // A filename is required: the transcription API picks its decoder from the
  // extension, and an unnamed blob is rejected as an unknown format.
  form.append('audio', audio, 'question.webm');

  try {
    const response = await ChessRestClient.post(
      `/video_learning/course/${bookUuid}/transcribe/`,
      form,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          // Left to the browser so it can add the multipart boundary; setting
          // it by hand produces a body the server cannot parse.
          'Content-Type': undefined as any,
        },
      },
    );
    const text = (response.data?.text ?? '').trim();
    return text || null;
  } catch {
    return null;
  }
}
